<script lang="ts" setup>
import { throttle } from 'lodash-es'

const lastId = ref(0)
const imageLib = ref<MediaLibImage[]>([])
const empty = ref(false)

const emit = defineEmits<{
  (e: 'choose', path: string): void
}>()

async function getLib() {
  lastId.value = 0
  const res = await fetchMediaLib(lastId.value)
  if (res.code === 1) {
    imageLib.value.push(...res.data.images)
  }
}

async function getMore() {
  if (empty.value) return
  lastId.value = imageLib.value[imageLib.value.length - 1].id
  const res = await fetchMediaLib(lastId.value)
  if (res.code === 1) {
    if (res.data.images.length === 0) {
      empty.value = true
      return
    }
    imageLib.value.push(...res.data.images)
  }
}

function onClick(e: MouseEvent) {
  const target = e.target as HTMLElement
  if (target.classList.contains('media-lib__img')) {
    const src = target.dataset.path as string
    emit('choose', src)
  }
}

function onScroll(e: Event) {
  throttle(
    () => {
      const target = e.target as HTMLElement
      const { scrollTop, clientHeight, scrollHeight } = target
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        getMore()
      }
    },
    1000,
    {
      leading: true
    }
  )()
}

getLib()
</script>

<template>
  <div class="media-lib" @click="onClick">
    <n-scrollbar
      :style="{
        maxHeight: '100%'
      }"
      @scroll="onScroll"
    >
      <div class="media-lib__wrap">
        <div v-for="img in imageLib" :key="img.id">
          <m-img
            :src="img.file_path"
            :data-path="img.file_path"
            class="media-lib__img"
          />
        </div>
      </div>
      <no-more v-if="empty" />
    </n-scrollbar>
  </div>
</template>

<style lang="scss" scoped>
.media-lib {
  width: 80vw;
  max-width: 1000px;
  height: 300px;
  padding: 0 12px;
  &__wrap {
    display: flex;
    flex-wrap: wrap;
  }
  &__img {
    width: 110px;
    height: 110px;
    margin: 5px;
    cursor: pointer;
  }
}
</style>
~/apis/image/images
